/* The quick-order box: typed SKUs -> a checked list -> a cart.

   Written by build/push-quick-order.py. This file is its source - change it here, not in the
   theme.

   Everything it talks to is this shop:
     assets/lupin-sku-index.json   our permanent product key -> product handle
     /products/<handle>.js         the live variants, so prices and availability are current
     /cart/add.js                  the cart
   Nothing here goes to another host, and no price or variant id is baked into the site.

   Why it checks before it adds. A typed SKU can be wrong, and a list of twenty is worse: the
   customer has to see what was recognised, at what price, before anything reaches the cart.
   So the button says "Check the list" first and only then offers "Add all to cart".

   Made-to-order products are refused by SKU range (data-made-to-order, "EIP"), because those
   carry required wording fields and a confirmation tick that a SKU cannot express. */
(function () {
  'use strict';

  var box = document.querySelector('[data-lupin-quick-order]');
  if (!box) return;

  var input = box.querySelector('.lp-qo__box');
  var checkBtn = box.querySelector('[data-lupin-qo-check]');
  var addBtn = box.querySelector('[data-lupin-qo-add]');
  var results = box.querySelector('[data-lupin-qo-results]');
  var msgEl = box.querySelector('[data-lupin-qo-msg]');
  var indexUrl = box.getAttribute('data-index');
  var madeToOrder = (box.getAttribute('data-made-to-order') || '')
    .split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);

  var keys = null;              // product key -> handle
  var products = {};            // handle -> promise of the product JSON
  var checked = [];             // the rows currently shown

  function msg(text, kind) {
    msgEl.textContent = text || '';
    msgEl.hidden = !text;
    msgEl.className = 'lp-qo__msg' + (kind ? ' lp-qo__msg--' + kind : '');
  }

  function money(cents) {
    // Shopify gives cents. Prices on this store include GST, so no adjustment is made here.
    return '$' + (cents / 100).toFixed(2);
  }

  function loadIndex() {
    if (keys) return Promise.resolve(keys);
    return fetch(indexUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (doc) {
        keys = (doc && doc.keys) || {};
        return keys;
      });
  }

  function loadProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js',
        { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return products[handle];
  }

  /* One typed line -> { sku, qty }. Accepts "SKU 4", "SKU,4", "SKU x4", "SKU" and tabs, which
     is what a paste out of a spreadsheet looks like. */
  function parseLine(line) {
    var text = line.replace(/ /g, ' ').trim();
    if (!text) return null;
    var m = text.match(/^([A-Za-z0-9-]+)(?:\s*[,\t]\s*|\s+x?\s*)?(\d+)?\s*$/i);
    if (!m) return { sku: text, qty: 1, bad: 'not-a-sku' };
    var qty = m[2] ? parseInt(m[2], 10) : 1;
    if (!(qty > 0)) qty = 1;
    if (qty > 999) qty = 999;
    return { sku: m[1].toUpperCase(), qty: qty };
  }

  function productKey(sku) {
    var i = sku.indexOf('-');
    return i > 0 ? sku.slice(0, i) : sku;
  }

  function rangeOf(key) {
    var m = key.match(/^([A-Z]+)/);
    return m ? m[1] : '';
  }

  function resolve(entry) {
    if (entry.bad) return Promise.resolve(entry);
    var key = productKey(entry.sku);
    if (madeToOrder.indexOf(rangeOf(key)) !== -1) {
      entry.bad = 'made-to-order';
      entry.handle = keys[key];
      return Promise.resolve(entry);
    }
    var handle = keys[key];
    if (!handle) {
      entry.bad = 'no-such-sku';
      return Promise.resolve(entry);
    }
    entry.handle = handle;
    return loadProduct(handle).then(function (p) {
      if (!p || !p.variants) {
        entry.bad = 'lookup-failed';
        return entry;
      }
      var hit = null;
      for (var i = 0; i < p.variants.length; i++) {
        if ((p.variants[i].sku || '').toUpperCase() === entry.sku) { hit = p.variants[i]; break; }
      }
      if (!hit) {
        entry.bad = 'no-such-sku';
        return entry;
      }
      entry.id = hit.id;
      entry.title = p.title;
      entry.option = hit.title === 'Default Title' ? '' : hit.title;
      entry.price = hit.price;
      entry.available = hit.available;
      return entry;
    });
  }

  var REASON = {
    'not-a-sku': 'not a SKU',
    'no-such-sku': 'no such SKU',
    'made-to-order': 'ordered on its own page',
    'lookup-failed': 'could not be looked up, please try again'
  };

  function render(rows) {
    var good = rows.filter(function (r) { return !r.bad; });
    var html = '<table class="lp-qo__table"><thead><tr>' +
      '<th>SKU</th><th>Product</th><th class="lp-qo--num">Qty</th>' +
      '<th class="lp-qo--num">Each</th><th class="lp-qo--num">Total</th>' +
      '</tr></thead><tbody>';
    rows.forEach(function (r) {
      if (r.bad) {
        var what = REASON[r.bad] || 'could not be added';
        var where = r.bad === 'made-to-order' && r.handle
          ? ' <a href="/products/' + encodeURIComponent(r.handle) + '">Open its page</a>'
          : ' <a href="/search?q=' + encodeURIComponent(r.sku) + '">Search for it</a>';
        html += '<tr class="lp-qo__row--bad"><td class="lp-qo__sku">' + esc(r.sku) + '</td>' +
          '<td colspan="4">' + what + '.' + where + '</td></tr>';
        return;
      }
      var name = esc(r.title) + (r.option ? ' <span class="lp-qo__opt">' + esc(r.option) + '</span>' : '');
      if (!r.available) name += ' (not available)';
      html += '<tr><td class="lp-qo__sku">' + esc(r.sku) + '</td>' +
        '<td><a href="/products/' + encodeURIComponent(r.handle) + '">' + name + '</a></td>' +
        '<td class="lp-qo--num">' + r.qty + '</td>' +
        '<td class="lp-qo--num">' + money(r.price) + '</td>' +
        '<td class="lp-qo--num">' + money(r.price * r.qty) + '</td></tr>';
    });
    if (good.length) {
      var total = good.reduce(function (n, r) { return n + r.price * r.qty; }, 0);
      html += '<tr class="lp-qo__total"><td colspan="4">' + good.length +
        (good.length === 1 ? ' line' : ' lines') + ', inc GST</td>' +
        '<td class="lp-qo--num">' + money(total) + '</td></tr>';
    }
    html += '</tbody></table>';
    results.innerHTML = html;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function check() {
    var lines = (input.value || '').split(/\r?\n/).map(parseLine).filter(Boolean);
    results.innerHTML = '';
    addBtn.hidden = true;
    checked = [];
    if (!lines.length) {
      msg('Put at least one SKU in the box.', 'bad');
      return;
    }
    msg('Checking ' + lines.length + (lines.length === 1 ? ' line...' : ' lines...'));
    checkBtn.disabled = true;
    loadIndex()
      .then(function () { return Promise.all(lines.map(resolve)); })
      .then(function (rows) {
        checked = rows;
        render(rows);
        var good = rows.filter(function (r) { return !r.bad && r.available; });
        var bad = rows.length - good.length;
        addBtn.hidden = good.length === 0;
        if (!good.length) msg('Nothing on the list can be added yet.', 'bad');
        else if (bad) msg(good.length + ' of ' + rows.length + ' lines are ready to add.', 'bad');
        else msg('All ' + rows.length + (rows.length === 1 ? ' line is' : ' lines are') + ' ready to add.', 'good');
      })
      .catch(function () {
        msg('The list could not be checked. Please try again.', 'bad');
      })
      .then(function () { checkBtn.disabled = false; });
  }

  function add() {
    var items = checked.filter(function (r) { return !r.bad && r.available; })
      .map(function (r) { return { id: r.id, quantity: r.qty }; });
    if (!items.length) return;
    addBtn.disabled = true;
    msg('Adding ' + items.length + (items.length === 1 ? ' line' : ' lines') + ' to your cart...');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error((e && e.description) || 'rejected'); });
        return r.json();
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (e) {
        addBtn.disabled = false;
        msg('The cart would not take the list: ' + (e && e.message ? e.message : 'please try again') + '.', 'bad');
      });
  }

  checkBtn.addEventListener('click', check);
  addBtn.addEventListener('click', add);
  // A change to the list invalidates what was checked, so the add button goes away until the
  // customer checks again. Adding a list they have edited but not re-read is how a wrong
  // order gets placed.
  input.addEventListener('input', function () {
    if (!addBtn.hidden) {
      addBtn.hidden = true;
      msg('The list has changed. Check it again.', null);
    }
  });
})();
